export const Marquee = (container, speed, scrollDirection = "left") => {
  let direction = scrollDirection === "right" ? "right" : "left"
  const parentSelector = container

  if (!parentSelector) return

  if (direction === "right") {
    parentSelector.classList.add("right-direction")
  }

  const clone = parentSelector.innerHTML
  const firstElement = parentSelector.children[0]

  if (!firstElement) return

  if (direction === "right") {
    parentSelector.insertAdjacentHTML("afterbegin", clone)
    parentSelector.insertAdjacentHTML("afterbegin", clone)
  } else {
    parentSelector.insertAdjacentHTML("beforeend", clone)
    parentSelector.insertAdjacentHTML("beforeend", clone)
  }

  let i = 0
  let lastTime = 0

  function animate() {
    const currentTime = performance.now()
    const deltaTime = currentTime - lastTime

    if (deltaTime > 10) {
      if (direction === "right") {
        firstElement.style.marginRight = `-${i}px`
      } else {
        firstElement.style.marginLeft = `-${i}px`
      }

      if (i > firstElement.clientWidth) {
        i = 0
      }

      i += speed
      lastTime = currentTime
    }

    requestAnimationFrame(animate)
  }

  requestAnimationFrame(animate)
}
